/**
 * Function to normalize and slugify an array of alphanumeric strings
 * @param args Arguments to slugify
 * @returns Slugified string
 */
export const slugify = (...args) => {
    const value = args.join(' ');
    return value
        .normalize('NFD') // Normalize the string in a way that removes diacritics and other non-standard characters
        .replace(/[\u0300-\u036f]/g, '') // remove all accents
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '') // remove all non-alphanumeric characters
        .replace(/\s+/g, '-'); // replace spaces with -
};
